export function addDevice({ devices, device, deviceType }: any) {
  if (!devices || !device) return

  const methrod = 'push'
  devices[methrod] &&
    devices[methrod]({
      label: device.label || deviceType + (devices.length + 1),
      id: device.deviceId,
      kind: device.kind,
      status: device.status && true,
    })
}

export async function getUserMediaList() {
  const deviceData = {
    audioInputDeviceList: [],
    audioOutputDeviceList: [],
    videoDeviceList: [],
  }

  try {
    const devices = await navigator.mediaDevices.enumerateDevices()

    devices.forEach((device) => {
      if (device.kind === 'videoinput') {
        addDevice({ devices: deviceData.videoDeviceList, device, deviceType: 'camera' })
      } else if (device.kind === 'audiooutput') {
        addDevice({ devices: deviceData.audioOutputDeviceList, device, deviceType: 'speaker' })
      } else if (device.kind === 'audioinput') {
        addDevice({ devices: deviceData.audioInputDeviceList, device, deviceType: 'microphone' })
      }
    })
  } catch (error) {
    console.error('shop', error)
  }
  return deviceData
}
